import { createFileRoute } from '@tanstack/react-router'

import { SupervisorsPage } from '@/features/user-management/SupervisorsPage'

export const Route = createFileRoute('/_authenticated/user-mgt/supervisors')({
  component: SupervisorsPage,
})
